import { FC } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

import DetailPage from './PollDetailPage';
import VotePage from './Vote';
import CreatePage from './New';
import WithdrawPage from './Withdraw';
import ReportPage from './Report';
import SwingVotePage from './SwingVote';
import PledgesPage from './Pledges';
import ProxyVotePage from './ProxyVote';
import PrivateRoute from '@components/App/PrivateRoute';

const PollRouter: FC = () => {
  const { path } = useRouteMatch();
  return (
    <div>
      <Switch>
        <PrivateRoute path={`${path}/create`}>
          <CreatePage />
        </PrivateRoute>
        <Route exact path={`/poll/:pollId`}>
          <DetailPage />
        </Route>
        <Route path={`${path}/:pollId/vote`}>
          <VotePage />
        </Route>
        <Route path={`${path}/:pollId/withdraw`}>
          <WithdrawPage />
        </Route>
        <Route path={`${path}/:pollId/report`}>
          <ReportPage />
        </Route>
        <Route path={`${path}/:pollId/swing-vote`}>
          <SwingVotePage />
        </Route>
        <Route path={`${path}/:pollId/proxy/vote`}>
          <ProxyVotePage />
        </Route>
        <Route path={`${path}/:pollId/pledges`}>
          <PledgesPage />
        </Route>
        <Route path={`${path}/:pollId/edit`}>
          <CreatePage edit={true} />
        </Route>
      </Switch>
    </div>
  );
};

export default PollRouter;
